import React from 'react';
import WorkflowFooter from '../../../shared/ui/workflow/WorkflowFooter';

/**
 * Footer fragment for the properties wizard step: readiness summary plus the
 * list of blocking reasons. Extracted from the page component to keep the
 * page file focused on state orchestration.
 */
export function buildProcessPropertiesFooterContent(input: {
  blockingReasons: string[];
  completedRequired: number;
  totalRequired: number;
}): React.ReactNode {
  return (
    <WorkflowFooter
      isReady={input.blockingReasons.length === 0}
      readyText={`${input.completedRequired}/${input.totalRequired} required mappings selected`}
      blockedReasons={input.blockingReasons}
    />
  );
}
